import React from 'react';
import './ItemsComp.less';
import { observer } from 'mobx-react';
import {IndexItem} from '../../../widgets'

// 订单状态
const headerStatus = (orderStatus: any): string => {
    let str: string = '';
    switch (orderStatus) {
        case 1:
            str =  '待支付';
            break;
        case -2:
            str =  '已删除';
            break;
        case -1:
            str =  '已取消';
            break;
        case 2:
            str =  '待发货';
            break;
        case 3:
            str =  '待收货';
            break;
        case 4:
        case 41:
        case 42:
            str =  '已完成';
            break;
        case 44:
            str =  '已收货';
            break;
        case 5:
            str =  '退款处理中';
            break;
        case 6:
            str =  '拒绝退款';
            break;
        case 7:
            str =  '已退款';
            break;
    }
    return str
};

// 头部组件
const Header = (prop: any) => {
    return (
        <div className={`${prop.prefixCls}-header`}>
            <span className={`${prop.prefixCls}-code`}>订单编号：{prop.data.orderId}</span>
            <span className={`${prop.prefixCls}-status`}>{headerStatus(prop.data.orderStatus)}</span>
        </div>
    );
};

// 底部组建
const Footer = (prop: any) => {
    return (
        <div className={`${prop.prefixCls}-footer`}>
            <div className={`${prop.prefixCls}-price`}>
                应付：<span>￥{prop.data.totalFee}</span>
            </div>
        </div>
    );
};

@observer
class ItemsComp extends React.Component<any> {
    static defaultProps = {
        prefixCls: 'items-comp'
    };

    render() {
        const {prefixCls, data} = this.props;
        return (
            <div className={`${prefixCls}-container`}>
                <Header {...this.props}/>
                {
                    data && data.itemDOs.map((value: any) => {
                        return (
                            <IndexItem
                                data={value}
                                styles={{padding: 0}}
                                key={value.id}
                            />
                        )
                    })
                }
                <Footer {...this.props}/>
            </div>
        );
    }
}

export default ItemsComp;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/mergeOrder/itemsComp/ItemsComp.tsx